import "core-js/modules/es.array.push.js";
import { onMounted, reactive, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import zhCn from "element-plus/es/locale/lang/zh-cn";
export default {
  name: "Invoice",
  setup() {
    const router = useRouter();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      activeName: 0,
      childActiveName: 0,
      invoiceTitleList: [],
      times: [],
      startTime: "",
      endTime: "",
      invoiceId: "",
      currentInvoiceTitle: "",
      tabsIndex: 0,
      tabs: ["运输服务", "平台服务", "月度结算"],
      comps: [{
        label: "发起结算",
        name: "InvoiceApply"
      }, {
        label: "结算情况",
        name: "InvoiceApplyProgress"
      }],
      serviceComps: [{
        label: "发票申请",
        name: "ServiceticketApply"
      }, {
        label: "申请中",
        name: "ServiceticketProgress"
      }, {
        label: "开票历史",
        name: "ServiceticketHistory"
      }],
      monthServiceComps: [{
        label: "发票申请",
        name: "MonthServiceticketApply"
      }, {
        label: "申请中",
        name: "MonthServiceticketProgress"
      }, {
        label: "开票历史",
        name: "MonthServiceticketHistory"
      }]
    });
    onMounted(() => {
      queryInvoiceTitle();
    });

    //查询发票抬头
    const queryInvoiceTitle = async () => {
      const res = await globalProperties.$api.selectOne();
      if (res) {
        data.invoiceTitleList = [res];
        data.invoiceId = data.invoiceTitleList[0].invoiceId;
        data.currentInvoiceTitle = data.invoiceTitleList[0];
      }
    };
    const toInvoiceTitle = () => {
      router.push({
        path: "/layout/personalinformation"
      });
    };
    const setTabsIndex = index => {
      data.tabsIndex = index;
      data.childActiveName = 0;
    };
    const setChildActiveName = index => {
      console.log(index);
      data.childActiveName = index;
    };
    return {
      data,
      toInvoiceTitle,
      zhCn,
      setTabsIndex,
      setChildActiveName
    };
  }
};